import { useEffect } from 'react'
import { useLocation } from 'react-router'

export function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto', // Use 'auto' instead of 'smooth' to prevent layout displacement issues during navigation
    })
  }, [pathname])

  return null
}
